<style lang="scss">
</style>

<template>
<div class="search-wrap">

    <article class="search-main clearfix">
        <div class="pull-left">
            <Button type="primary" @click="handleModal('init')">批量初始化</Button>
        </div>
        <div class="pull-right">
            <Form :label-width="60" inline>
                <FormItem label='ERPSKU'>
                    <Input clearable v-model.trim="formData.CN_erpSku"/>
                </FormItem>
                <FormItem label='项目'>
                    <Select clearable v-model="formData.EQ_lineId" filterable >
                        <Option value="">所有</Option>
                        <Option v-for="item in getNewProductList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <FormItem :label-width="1">
                    <Button type="primary" @click="update" icon="ios-search">搜索</Button>
                    <Button @click="reset" icon='md-refresh'>重置</Button>
                </FormItem>
            </Form>
        </div>
    </article>
</div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'

export default {
    data() {
        return {
            formData: {
                CN_erpSku: '',
                EQ_lineId: '',
            },
        };
    },
    mounted() {
        this.update();
    },
    computed: {
        // ...mapState('boss',['products']),
        ...mapGetters('diction',['getNewProductList']),
    },
    methods: {
        handleModal(type, id) {
            this.$parent.handleOperates(id, type);
        },
        update() {
            this.$emit('on-update', {
                search: {
                    ...this.formData
                },
                page: 1
            });
        },
        reset() {
            this.formData = {
                CN_erpSku: '',
                EQ_lineId: '',
            };
            this.$emit('on-update', {
                search: {
                    ...this.formData
                },
                page: 1,
            });
        },

    },
};
</script>
